import type { TRootState } from 'store';
import type { ISelector } from 'interfaces/Selector.interface';
import { createSelectorSlice } from 'redux/collections/helper/createSelector.slice';
import {
  currentPageDefault,
  itemsPerPageDefault,
} from 'redux/collections/consts/selectorDefaults.consts';

export const timesheetsSlice = createSelectorSlice(
  'paginatedTimesheets',
  currentPageDefault,
  itemsPerPageDefault,
  { columnKey: 'createdAt', direction: 'desc' }
);

const { actions, reducer } = timesheetsSlice;

export const {
  setPagination,
  setNextPage,
  setSorting,
  setItemsPerPage,
  setFilters,
} = actions;

export const paginatedTimesheetsSelector = (state: TRootState): ISelector =>
  state.collectionTimesheets;

export default reducer;
